// Rutas del front (pantallas) y endpoints del backend (mod_aws_arq, bajo REACT_APP_URL_API).
const proyectosRoute = '/Aws/Proyectos'
const proyectoRoute = '/Aws/Proyecto'
const diagramaRoute = '/Aws/Diagrama'
const manualRoute = '/Aws/Manual'
const guiaRoute = '/Aws/Guia'
const presentacionRoute = '/Aws/Presentacion'
const productoRoute = '/Aws/Producto'     // la misma presentacion, publica (sin login), ver src/index.js

const proyectoList = '/proyectoList'
const proyectoEdit = '/proyectoEdit'
const proyectoGuardar = '/proyectoGuardar'
const proyectoEli = '/proyectoEli'

const diagramaList = '/diagramaList'
const diagramaGet = '/diagramaGet'
const diagramaGuardar = '/diagramaGuardar'
const diagramaEli = '/diagramaEli'

const terraformImportar = '/terraformImportar'
const terraformAgregar = '/terraformAgregar'
const diagramaVersiones = '/diagramaVersiones'
const diagramaVersionGet = '/diagramaVersionGet'
const plantillaEmpList = '/plantillaEmpList'
const plantillaEmpGuardar = '/plantillaEmpGuardar'
const plantillaEmpEli = '/plantillaEmpEli'
const precioList = '/precioList'
const precioGuardar = '/precioGuardar'
const precioEli = '/precioEli'
const compartirCrear = '/compartirCrear'
const compartirList = '/compartirList'
const compartirRevocar = '/compartirRevocar'
const compartido = '/free/compartido'
const cuentaClavePublica = '/cuentaClavePublica'
const cuentaImportar = '/cuentaImportar'
const cuentaComparar = '/cuentaComparar'
const cuentaAgregar = '/cuentaAgregar'
const plantillaList = '/plantillaList'
const diagramaDesdePlantilla = '/diagramaDesdePlantilla'

module.exports = {
	proyectosRoute, proyectoRoute, diagramaRoute, manualRoute, guiaRoute, presentacionRoute, productoRoute,
	proyectoList, proyectoEdit, proyectoGuardar, proyectoEli,
	diagramaList, diagramaGet, diagramaGuardar, diagramaEli,
	plantillaList, diagramaDesdePlantilla, terraformImportar, terraformAgregar,
	precioList, precioGuardar, precioEli, compartirCrear, compartirList, compartirRevocar, compartido, cuentaClavePublica, cuentaImportar, cuentaComparar, cuentaAgregar,
	diagramaVersiones, diagramaVersionGet, plantillaEmpList, plantillaEmpGuardar, plantillaEmpEli,
}
